(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["germano-editorial-quartet"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-ge-quartet]:not([data-ready])').forEach(section => {
    section.dataset.ready = 'true';
    const rail = section.querySelector('.ge-quartet__rail');
    const pages = [...rail.querySelectorAll('.ge-quartet__page')];
    const dots = [...section.querySelectorAll('[data-ge-page]')];
    const previous = section.querySelector('[data-ge-prev]');
    const next = section.querySelector('[data-ge-next]');
    if (!previous || !next) return;
    let current = 0;
    const go = index => rail.scrollTo({ left: Math.max(0, Math.min(pages.length - 1, index)) * rail.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    const update = () => {
      current = Math.round(rail.scrollLeft / Math.max(rail.clientWidth, 1));
      previous.disabled = current === 0;
      next.disabled = current >= pages.length - 1;
      section.querySelector('[data-ge-current]').textContent = String(current + 1);
      dots.forEach((dot, index) => index === current ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
    };
    previous.addEventListener('click', () => go(current - 1));
    next.addEventListener('click', () => go(current + 1));
    dots.forEach(dot => dot.addEventListener('click', () => go(Number(dot.dataset.gePage))));
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('keydown', event => {
      if (event.target !== rail) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    if ('ResizeObserver' in window) new ResizeObserver(() => { rail.scrollLeft = current * rail.clientWidth; update(); }).observe(rail);
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["germano-editorial-ugc"] && !Shopify.designMode) return;
  try {
    
(() => {
  const process = () => window.instgrm?.Embeds?.process();
  const load = () => {
    if (window.instgrm?.Embeds) { process(); return; }
    let script = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
    if (script) { script.addEventListener('load', process, { once: true }); return; }
    script = document.createElement('script'); script.src = 'https://www.instagram.com/embed.js'; script.async = true; script.addEventListener('load', process, { once: true }); document.head.appendChild(script);
  };
  const init = () => document.querySelectorAll('[data-ge-ugc]:not([data-ready])').forEach(section => {
    section.dataset.ready = 'true';
    section.querySelectorAll('[data-ge-photo]').forEach(photo => {
      let observedFrame;
      const fit = () => {
        const frame = photo.querySelector('iframe.instagram-media');
        if (!frame) return;
        if (observedFrame !== frame) { observedFrame = frame; if ('ResizeObserver' in window) new ResizeObserver(fit).observe(frame); }
        const mediaHeight = frame.offsetHeight - 210;
        if (mediaHeight <= 0) return;
        const scale = Math.max(photo.clientWidth / 326, photo.clientHeight / mediaHeight);
        const x = (photo.clientWidth - 326 * scale) / 2;
        const transform = 'translate(' + x + 'px,' + (-54 * scale) + 'px) scale(' + scale + ')';
        if (frame.style.transform !== transform) frame.style.transform = transform;
        photo.dataset.photoReady = 'true';
      };
      new MutationObserver(fit).observe(photo, { childList: true, subtree: true, attributes: true, attributeFilter: ['height', 'class'] });
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(photo);
      fit();
    });
    if (!section.querySelector('.instagram-media')) return;
    if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { load(); observer.disconnect(); } }, { rootMargin: '300px' }); observer.observe(section); } else load();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["germano-ugc-clean"] && !Shopify.designMode) return;
  try {
    
(() => {
  const loadEmbeds = () => {
    if (window.instgrm?.Embeds) {
      window.instgrm.Embeds.process();
      return;
    }
    const existing = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
    if (existing) return;
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    script.onload = () => window.instgrm?.Embeds?.process();
    document.head.appendChild(script);
  };
  const initCrops = () => {
    document.querySelectorAll('.germano-ugc-clean__viewport:not([data-crop-observed])').forEach(viewport => {
      viewport.dataset.cropObserved = 'true';
      let observedFrame;
      const update = () => {
        const frame = viewport.querySelector('iframe.instagram-media-rendered');
        if (!frame) return;
        if (frame !== observedFrame) {
          observedFrame = frame;
          if ('ResizeObserver' in window) new ResizeObserver(update).observe(frame);
        }
        const height = frame.getBoundingClientRect().height;
        const trim = Number(viewport.dataset.footerTrim) || 0;
        if (height <= trim) return;
        const visibleHeight = (height - trim) + 'px';
        if (viewport.style.getPropertyValue('--ugc-visible-height') !== visibleHeight) viewport.style.setProperty('--ugc-visible-height', visibleHeight);
        if (!viewport.hasAttribute('data-cropped')) viewport.dataset.cropped = 'true';
      };
      new MutationObserver(update).observe(viewport, { childList: true, subtree: true, attributes: true, attributeFilter: ['height', 'style', 'class'] });
      update();
    });
  };
  const observeSections = () => {
    initCrops();
    const sections = document.querySelectorAll('[data-germano-ugc-clean]:not([data-ugc-observed])');
    sections.forEach(section => {
      section.dataset.ugcObserved = 'true';
      if (!section.querySelector('.instagram-media')) return;
      if (!('IntersectionObserver' in window)) { loadEmbeds(); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          loadEmbeds();
          observer.disconnect();
        }
      }, { rootMargin: '300px' });
      observer.observe(section);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSections, { once: true });
  } else {
    observeSections();
  }
  document.addEventListener('shopify:section:load', observeSections);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["germano-ugc"] && !Shopify.designMode) return;
  try {
    
(() => {
  const loadEmbeds = () => {
    if (window.instgrm?.Embeds) {
      window.instgrm.Embeds.process();
      return;
    }
    const existing = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
    if (existing) return;
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    script.onload = () => window.instgrm?.Embeds?.process();
    document.head.appendChild(script);
  };
  const observeSections = () => {
    const sections = document.querySelectorAll('[data-germano-ugc]:not([data-ugc-observed])');
    sections.forEach(section => {
      section.dataset.ugcObserved = 'true';
      if (!section.querySelector('.instagram-media')) return;
      if (!('IntersectionObserver' in window)) { loadEmbeds(); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          loadEmbeds();
          observer.disconnect();
        }
      }, { rootMargin: '300px' });
      observer.observe(section);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSections, { once: true });
  } else {
    observeSections();
  }
  document.addEventListener('shopify:section:load', observeSections);
})();

  } catch(e) { console.error(e); }
})();
})();
